// imports

// component
export default {

    props: {
        name: {
            type:    String,
            default: '',
        },

        loading: {
            type:    Boolean,
            default: false,
        },

        modifiers: {
            type:    Array,
            default: () => [],
        },
    },

    components: {

    },

    mixins: [

    ],

    mounted () {

    },

    data () {
        return {

        };
    },

    computed: {

    },

    methods: {

    },

    watch: {

    },
};
